<template>
  <div class="class-detail-root">
    <div class="class-header-card">
      <div class="class-header-main">
        <div class="class-title-row">
          <span class="class-type">{{ state.classType }}</span>
          <span class="class-year">{{ state.classYear }}届</span>
        </div>
        <div class="class-location">{{ state.classSchool }} {{ state.classRoom }}</div>
      </div>
    </div>

    <div class="class-section-list">
      <div class="class-section-card" @click="goStudent">
        <div class="section-title">学生</div>
        <div class="section-action">
          <span class="section-link">在课：{{ state.studentCount }}</span>
          <svg class="arrow-icon" width="18" height="18" viewBox="0 0 24 24"><path d="M9 6l6 6-6 6" stroke="#2466f6" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </div>
      </div>
      <div class="class-section-card" @click="goTeacher">
        <div class="section-title">授课老师</div>
        <div class="section-action">
          <svg class="arrow-icon" width="18" height="18" viewBox="0 0 24 24"><path d="M9 6l6 6-6 6" stroke="#2466f6" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </div>
      </div>
      <div class="class-section-card" @click="goCalendar">
        <div class="section-title">课程日历</div>
        <div class="section-action">
          <span class="section-link blue">今日课程：{{ state.todayLessonCount }}</span>
          <svg class="arrow-icon" width="18" height="18" viewBox="0 0 24 24"><path d="M9 6l6 6-6 6" stroke="#2466f6" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </div>
      </div>
      <div class="class-section-card" @click="goRecord">
        <div class="section-title">上课记录</div>
        <div class="section-action">
          <svg class="arrow-icon" width="18" height="18" viewBox="0 0 24 24"><path d="M9 6l6 6-6 6" stroke="#2466f6" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, reactive, ref } from "vue";
import EmptyDataCard from "@/components/EmptyDataCard.vue";
import { queryClassDetail } from "@/api/user";
import { useRoute,useRouter } from "vue-router";
import { showToast } from "vant";
export default defineComponent({
  name: "GaoBuTeacher",

  components: {
    EmptyDataCard,
  },

  setup() {
    const route = useRoute();
    const router = useRouter();

    console.log(route);

    const state = reactive({
      teacherList: [],
      videoList: [],
      className: null,
      classType: '理科班',
      classYear: '2025',
      classSchool: '成都武侯分校',
      classRoom: '115室',
      studentCount: 7,
      todayLessonCount: 12
    });
    onMounted(() => {
      if(route?.query?.token) {
        localStorage.setItem('token', route?.query?.token)
      }
      queryClassDetailData();
    });

    const queryClassDetailData = async () => {
      try {
        const result = await queryClassDetail({
          createOrg: route?.query?.creatOrg,
          id: route?.query?.classId,
        });
        console.log('result: ' + result)
        if (result.code === "00") {
          state.videoList = result.data?.videoList ?? []
          state.teacherList = result.data?.teacherList ?? []
          state.className = result.data?.className ?? '--'
          state.studentCount = result.data?.studentCount ?? 0
          state.todayLessonCount = result.data?.todayLessonCount ?? 0
        } else {
        }
      } catch (error) {
        console.log("error:>>>", error);
      }
    };

    const getChildren = (row) => {
      if (!row) {
        return [];
      }
      return row.split("\n");
    };

    function handleGoDetail(row) {
        console.log('row>>>>>', row);
        router.push({
            path: '/teacherDetail',
            query: {
                id: row.teacherInfo.id,
                creatOrg: route?.query?.creatOrg
            }
        })
    }

    const goStudent = () => {
      // 跳转学生列表
      router.push({
        path: '/gaobu/studentList',
        query: {
          classId: route?.query?.classId,
          creatOrg: route?.query?.creatOrg
        }
      });
    }
    const goTeacher = () => {
      // 跳转授课老师
    }
    const goCalendar = () => {
      // 跳转课程日历
    }
    const goRecord = () => {
      // 跳转上课记录
    }

    return {
      state,
      getChildren,
      handleGoDetail,
      goStudent,
      goTeacher,
      goCalendar,
      goRecord
    };
  },
});
</script>

<style lang="scss" scoped>
.class-detail-root {
  min-height: 100vh;
  background: linear-gradient(180deg, #f7faff 0%, #f2f3f7 100%);
  padding-bottom: 32px;
}
.class-header-card {
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 4px 24px 0 rgba(36,102,246,0.06), 0 1.5px 4px 0 rgba(0,0,0,0.03);
  margin: 0 16px 24px 16px;
  padding: 28px 24px 18px 24px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 18px;
  position: relative;
  top: 24px;
}
.class-header-main {
  flex: 1;
  min-width: 0;
}
.class-title-row {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 7px;
}
.class-type {
  font-size: 20px;
  font-weight: 700;
  color: #2466f6;
  letter-spacing: 0.5px;
}
.class-year {
  font-size: 15px;
  color: #7a8599;
  font-weight: 500;
  margin-left: 2px;
}
.class-location {
  color: #7a8599;
  font-size: 14px;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}
.class-section-list {
  margin: 48px 0 0 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 0 16px;
}
.class-section-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 12px 0 rgba(36,102,246,0.04), 0 1px 2px 0 rgba(0,0,0,0.02);
  padding: 20px 18px 18px 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: box-shadow 0.18s, transform 0.18s;
  position: relative;
  overflow: hidden;
  &:active {
    box-shadow: 0 8px 32px 0 rgba(36,102,246,0.13);
    transform: scale(0.98);
  }
}
.section-title {
  font-size: 17px;
  font-weight: 600;
  color: #222;
}
.section-action {
  display: flex;
  align-items: center;
  gap: 8px;
}
.section-link {
  color: #2466f6;
  font-weight: 600;
  font-size: 15px;
}
.section-link.blue {
  color: #2466f6;
}
.arrow-icon {
  display: flex;
  align-items: center;
}
@media (max-width: 600px) {
  .class-header-card {
    padding: 18px 10px 12px 10px;
    border-radius: 14px;
  }
  .class-title-row {
    font-size: 16px;
  }
  .class-section-card {
    padding: 14px 10px 10px 12px;
    border-radius: 12px;
  }
}
</style>